import React, { useEffect } from 'react';
import { useStoreActions, useStoreState } from '../store';

export interface VHSProviderProps {
  children: React.ReactNode;
}

export function VHSProvider(props: VHSProviderProps) {
  const vhsActions = useStoreActions(actions => actions.vhs);
  const config = useStoreState(state => state.config);
  const enabled = useStoreState(state => state.vhs.enabled);

  useEffect(() => {
    // Enables the VHS functionality
    if (!enabled) {
      vhsActions.initialize();
    }
  }, [config, enabled]);

  return <>{props.children}</>;
}
